import { render, staticRenderFns } from "./OfferDetailsModal.vue?vue&type=template&id=52d44e80&scoped=true&"
import script from "./OfferDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OfferDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./OfferDetailsModal.vue?vue&type=style&index=0&id=52d44e80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d44e80",
  null
  
)

export default component.exports